function withOutAuth(WrapperComponent: any) {
  return (props: any) => {
    return <WrapperComponent {...props} />
  }
}

export default withOutAuth
